import { vars } from '@etg/wings';
import { css, cx } from '@eti/styles';
import { PlusCircle, MinusCircle } from '@phosphor-icons/react';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const getButtonStyles = isDisabled => css`
  background-color: transparent;
  border: none;
  color: ${isDisabled ? '#e5e5e5' : vars.colors.links.default};
  cursor: ${isDisabled ? 'default' : 'pointer'};
  display: flex;
  outline: none;
  padding: 0;

  &:active {
    transform: scale(${isDisabled ? '1' : '0.9'});
  }
`;
const wrapperStyles = css`
  align-items: center;
  display: flex;
`;
const CounterButton = _ref => {
  let {
    children,
    dataTestId,
    isDisabled,
    onClick
  } = _ref;
  return /*#__PURE__*/_jsx("button", {
    className: getButtonStyles(isDisabled),
    "data-testid": dataTestId,
    disabled: isDisabled,
    onClick: onClick,
    type: "button",
    children: children
  });
};
const hiddenNumberInputStyles = css`
  clip: rect(0 0 0 0);
  height: 1px;
  opacity: 0;
  position: absolute;
  width: 1px;
  z-index: -1;
`;
const currentValueStyles = css`
  align-items: center;
  display: flex;
  font-size: 1.25rem;
  height: 100%;
  justify-content: center;
  margin: 0 4px;
  width: 24px;
`;
const Counter = _ref2 => {
  let {
    className,
    hasMinusDisabled,
    hasPlusDisabled,
    id,
    max,
    min,
    onMinusClick,
    onPlusClick,
    value
  } = _ref2;
  return /*#__PURE__*/_jsxs("div", {
    className: cx('etiCounter', wrapperStyles, className),
    children: [/*#__PURE__*/_jsx(CounterButton, {
      dataTestId: `counter-${id}-minus-button`,
      isDisabled: hasMinusDisabled,
      onClick: onMinusClick,
      children: /*#__PURE__*/_jsx(MinusCircle, {
        color: "currentColor",
        size: "24px"
      })
    }), /*#__PURE__*/_jsx("input", {
      className: hiddenNumberInputStyles,
      max: max,
      min: min,
      readOnly: true,
      type: "number",
      value: value
    }), /*#__PURE__*/_jsx("div", {
      className: currentValueStyles,
      "data-testid": `counter-${id}-value`,
      children: value
    }), /*#__PURE__*/_jsx(CounterButton, {
      dataTestId: `counter-${id}-plus-button`,
      isDisabled: hasPlusDisabled,
      onClick: onPlusClick,
      children: /*#__PURE__*/_jsx(PlusCircle, {
        color: "currentColor",
        size: "24px"
      })
    })]
  });
};
export default Counter;
//# sourceMappingURL=Counter.js.map